module.exports = __webpack_public_path__ + "images/top-trending-black-c09cb80b.svg";